// extracted by mini-css-extract-plugin
export default {"container":"styles_container__S1D0O","btnContainer":"styles_btnContainer__QMx14","checkBoxLabel":"styles_checkBoxLabel__Qv1dT"};